module.exports = __webpack_public_path__ + "static/media/menhealth.e4e32541.svg";